<strong>OFFICE(S)</strong>
@if (!officesRefreshing) {
  <div>
    @if (providerOffices) {
      <div class="row">
        <ul class="list-unstyled scrollable">
          @for (providerOffice of providerOffices; track providerOffice) {
            <li
              class="office p-2">
              <app-office
                [office]="providerOffice.office"
                [providerOffice]="providerOffice" />
            </li>
          }
        </ul>
      </div>
    }
    @if (providerOffices.length === 0) {
      <div class="fst-italic">
        No prescriber offices in supplemental data
      </div>
    }
  </div>
}
